import { Button, DialogClose, InterceptDialog } from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import simulationImage from "@/assets/fr/carbonCalculator.png";
import { PortalContainerContext, UserContext } from "@/contexts";
import useOutboundQueryParams from "@/hooks/useOutboundQueryParams";
import useSegmentEvent from "@/hooks/useSegmentEvent";

interface UpsellModalProps {
  children: React.ReactNode;
}

const UpsellModal = ({ children }: UpsellModalProps) => {
  const { user } = use(UserContext);
  const { container } = use(PortalContainerContext);
  const { t } = useTranslation("simulation");
  const { sendSegmentEvent } = useSegmentEvent();
  const outboundQueryParams = useOutboundQueryParams("options");

  return (
    <InterceptDialog
      show={!user?.policies?.simulation.queries["create"]}
      title={t("modal.title")}
      description={t("modal.optionContent")}
      warningMessage={t("modal.optionWarning")}
      portalContainer={container as Element}
      content={
        <img src={simulationImage} alt={t("simulation:modal.imageAltText")} />
      }
      footer={
        <>
          <DialogClose asChild>
            <Button
              as={Link}
              to="/options/subscription?option=simulation"
              shape="link"
              onClick={() => sendSegmentEvent("option_subscription")}
            >
              {t("modal.secondaryCta")}
            </Button>
          </DialogClose>
          <DialogClose>
            <Button
              as="a"
              href={`https://meetings-eu1.hubspot.com/emmanuelle-vignial/demo-options-carbo${outboundQueryParams}`}
              shouldOpenNewTab
              onClick={() => sendSegmentEvent("option_demo")}
            >
              {t("modal.primaryCta")}
            </Button>
          </DialogClose>
        </>
      }
    >
      {children}
    </InterceptDialog>
  );
};

export default UpsellModal;
